import { render } from "./Technical.vue?vue&type=template&id=f6f3b320&scoped=true"
import script from "./Technical.vue?vue&type=script&lang=ts"
export * from "./Technical.vue?vue&type=script&lang=ts"

import "./Technical.vue?vue&type=style&index=0&id=f6f3b320&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f6f3b320"

export default script